<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-12">
          <div v-if="editMode === true" class="font-weight-bold btn border-secondary w-100 text-left immediate_cause" data-toggle="modal" :data-target="'#'+id">
            Substandard Act & Condition
            <div class="pl-1" v-for="item in data">
              <div class="pl-4" v-for="causeItem in item.data">
                <template v-if="causeItem.checked">
                  <font-awesome-icon
                    style="font-size: 5px; margin-bottom: 2px"
                    icon="circle"/>
                  {{ causeItem.name }}

                  <div class="pl-4" v-for="subCause in causeItem.sub_causes">
                    <template v-if="subCause.checked">
                      <font-awesome-icon
                        style="font-size: 5px; margin-bottom: 2px"
                        icon="circle"/>
                      {{ subCause.name }}
                    </template>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div v-else class="font-weight-bold btn border-secondary w-100 text-left">
            Substandard Act & Condition
            <div class="pl-1" v-for="item in data">
              <div class="pl-4" v-for="causeItem in item.data">
                <template v-if="causeItem.checked">
                  <font-awesome-icon
                    style="font-size: 5px; margin-bottom: 2px"
                    icon="circle"/>
                  {{ causeItem.name }}
                  <div class="pl-4" v-for="subCause in causeItem.sub_causes">
                    <template v-if="subCause.checked">
                      <font-awesome-icon
                        style="font-size: 5px; margin-bottom: 2px"
                        icon="circle"/>
                      {{ subCause.name }}
                    </template>
                  </div>
                </template>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="modal fade" data-backdrop="static" data-keyboard="false" :id="id" tabindex="-2" :aria-labelledby="id + 'Label'" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <form class="modal-content" @submit.prevent="">
          <div class="modal-header">
            <h2 style="font-weight: bold" class="text-uppercase">Substandard Act & Condition</h2>
          </div>
          <div class="modal-body" style="min-height: 200px; max-height: 450px; overflow-y: auto;">
            <div class="pl-1" v-for="item in items">
              <h3 style="font-weight: bold" class="text-uppercase">{{ item.text }}</h3>
              <div class="pl-4" v-for="causeItem in item.data">
                <input
                  @click="toggleMainCause(causeItem, causeItem.sub_causes)"
                  v-model="causeItem.checked" type="checkbox" class="align-middle"
                  :value="causeItem.id" name="item"
                  :disabled="causeItem.checked === false && totalSelected > 9"
                >
                <span class="mx-2 align-middle cursor-pointer no-select"
                      style="font-size: 18px;"
                      @click="toggleMainCause(causeItem, causeItem.sub_causes)"
                      :style="{fontWeight: causeItem.checked === true ? 'bold' : ''}"
                >
                  {{causeItem.name ? causeItem.name.toUpperCase() : ''}}
                </span>
                  <div class="pl-5" v-for="subCause in causeItem.sub_causes">
                    <input
                      :disabled="(causeItem.checked === false) || (subCause.checked === false && totalSelected > 9)"
                      v-model="subCause.checked"
                      type="checkbox"
                      class="align-middle"
                      :value="subCause.id"
                      name="item"
                    >
                    <span
                      v-if="causeItem.checked === false"
                      class="mx-2 align-middle cursor-pointer no-select"
                      style="font-size: 18px;"
                    >
                      {{subCause.name ? subCause.name.toUpperCase() : ''}}
                    </span>
                    <span v-else
                          class="mx-2 align-middle cursor-pointer no-select"
                          style="font-size: 18px;"
                          @click="toggleSubCause(subCause)"
                          :style="{fontWeight: subCause.checked === true ? 'bold' : ''}"
                    >
                      {{subCause.name ? subCause.name.toUpperCase() : ''}}
                    </span>
                  </div>
              </div>
              <br>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-between align-items-center w-100">
            <div class="d-flex align-items-center flex-wrap">
              <span style="font-size: 1rem">Total Selected: </span>
              <h4 class="pl-1 mb-0" style="margin-top: -3px; font-weight: bold">
                {{ totalSelected }}
              </h4>
              <template v-if="totalSelected > 9">
                <span class="pl-1" style="margin-top: 3px;">
                  (<span class="e-text-red">maximum selection reached</span>)
                </span>
              </template>
            </div>
            <div class="d-flex gap-2">
              <button type="button" class="btn btn-sm btn-secondary" @click="cancelSelected">Cancel</button>
              <button type="button" class="ml-1 btn btn-sm btn-primary" @click="doneSelected" :disabled="totalSelected > 10">Done</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "ImmediateCauseAndConditionSelector",
  data(){
    return{
      items : []
    }
  },
  props:{
    data:{
      type: Array,
      default:[],
    },
    id:{
      type:String,
      default: 'multiSelect'
    },
    editMode : {
      type : Boolean,
      default : true
    }
  },
  computed:{
    totalSelected() {
      let count = 0;

      this.items.forEach(item => {
        item.data.forEach(data => {
          if (data.checked === true) {
            count++;
          }

          data.sub_causes.forEach(subCauses => {
            if (subCauses.checked === true) {
              count++;
            }
          })
        })
      })

      return count;
    },
    newImmediateCauses() {
      const values = [];
      const items = JSON.parse(JSON.stringify(this.items));
      items.forEach(item => {
        item.data.forEach(data => {
          const newSubCauses = [];
          if (data.checked === true) {
            data.sub_causes.forEach(cause => {
              if (cause.checked === true) {
                newSubCauses.push(cause);
              }
            })
            data.sub_causes = newSubCauses;
            values.push(data)
          }
        })
      })

      return values;
    },
  },
  methods:{
    toggleMainCause(mainCause, subCauses) {
      if (mainCause.checked === false && this.totalSelected > 9) {
        return;
      }
      const newValue = !mainCause.checked;
      mainCause.checked = newValue;

      if (newValue === false) {
        subCauses.forEach(subCause => {
          subCause.checked = false;
        })
      }
    },
    toggleSubCause(subCause) {
      if (subCause.checked === false && this.totalSelected > 9) {
        return;
      }
      subCause.checked = !subCause.checked
    },
    doneSelected(){
      $('#'+this.id).modal('hide');
      this.$emit('doneSelected',{immediate_causes :this.newImmediateCauses});
    },
    cancelSelected() {
      $('#'+this.id).modal('hide');
      setTimeout(() => {
        this.items = JSON.parse(JSON.stringify(this.data));
      }, 500);
    },
  },
  mounted() {
    $('#' + this.id).find('.modal-content').css({
      boxShadow : '0 0 10px 10px rgba(0, 0, 0, 0.5)',
      minHeight : '500px',
      maxHeight : '500px',
    });
  },
  watch:{
    data: {
      handler(newVal) {
        this.items = JSON.parse(JSON.stringify(newVal));
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
    input[type='checkbox']{
      width: 20px;
      height: 20px;
    }
    .modal-dialog{
      overflow-y: initial !important
    }
    .modal-body{
      max-height: calc(100vh - 200px);
      overflow-y: auto;
    }


    .input-group .btn-link {
      padding: 0;
      border: none;
      font-size: 1.25rem;
      color: #000;
      text-decoration: none;
      position: absolute;
      right: 5px;
      z-index: 1000;
    }

    .input-group .btn-link:hover {
      color: #000;
      text-decoration: none;
      background-color: transparent;
    }

    .input-group .btn-link:focus {
      box-shadow: none;
    }

    .immediate_cause:hover {
      background-color: #dae8f4;
    }
</style>
